import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconVerifiedUserLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m10.95 13.065-1.592-1.592a.734.734 0 0 0-.523-.228.715.715 0 0 0-.531.228.736.736 0 0 0-.233.535c0 .2.078.379.233.534l2.013 2.03c.181.18.392.27.633.27s.452-.09.633-.27l4.144-4.145a.742.742 0 0 0 0-1.07.735.735 0 0 0-.535-.232.735.735 0 0 0-.534.233l-3.708 3.707ZM12 21.371a1.855 1.855 0 0 1-.596-.1c-2.11-.75-3.787-2.08-5.034-3.99-1.247-1.909-1.87-3.97-1.87-6.181V6.596c0-.378.11-.72.329-1.024.22-.304.501-.525.846-.662l5.692-2.125c.214-.077.425-.116.633-.116.208 0 .419.039.633.116l5.692 2.125c.345.137.627.358.846.662.22.305.329.646.329 1.024V11.1c0 2.211-.623 4.272-1.87 6.182-1.247 1.91-2.925 3.239-5.034 3.989a1.854 1.854 0 0 1-.596.1Zm0-1.471c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5V6.586a.298.298 0 0 0-.053-.173.318.318 0 0 0-.149-.115l-5.692-2.125a.282.282 0 0 0-.106-.02.282.282 0 0 0-.106.02L6.202 6.298a.318.318 0 0 0-.149.115.298.298 0 0 0-.053.173V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconVerifiedUserLine;
